"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcDropdown = void 0;
var util_1 = require("@aperza/util");
var react_1 = __importStar(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var AcDropdownItem_1 = require("./AcDropdownItem");
var AcDropdownLinkToggle_1 = require("./AcDropdownLinkToggle");
var AcDropdownToggle_1 = require("./AcDropdownToggle");
var AcDropdown = function (props) {
    var _a = props.id, id = _a === void 0 ? "ac_action_dropdown_" + util_1.UUIDUtil.uuid() : _a, title = props.title, _b = props.align, align = _b === void 0 ? 'left' : _b, _c = props.actions, actions = _c === void 0 ? [] : _c, data = props.data, functionContext = props.functionContext, dropdownClassName = props.dropdownClassName, disableDropdownIcon = props.disableDropdownIcon, _d = props.disabled, disabled = _d === void 0 ? false : _d, readOnly = props.readOnly, dropdownSize = props.dropdownSize, toggleAs = props.toggleAs, _e = props.toggleVariant, toggleVariant = _e === void 0 ? 'link' : _e, toggleSize = props.toggleSize, toggleClassName = props.toggleClassName, toggleActive = props.toggleActive, _f = props.menuMinWidth, menuMinWidth = _f === void 0 ? 190 : _f, displayOnHover = props.displayOnHover, styles = props.styles, onMouseDown = props.onMouseDown, children = props.children;
    var _g = __read(react_1.useState(false), 2), showMenu = _g[0], setShowMenu = _g[1];
    var titleNode;
    if (typeof title === 'function') {
        titleNode = title(data || {}, functionContext || {});
    }
    else {
        titleNode = title;
    }
    var toggleClassNameNode;
    if (typeof toggleClassName === 'function') {
        toggleClassNameNode = toggleClassName(data || {}, functionContext || {});
    }
    else {
        toggleClassNameNode = toggleClassName;
    }
    var renderStyle = function () {
        var cssStyles = {};
        return styles || cssStyles;
    };
    return (react_1.default.createElement(react_bootstrap_1.Dropdown, { alignRight: align === 'right', drop: "down", onMouseEnter: function () { return displayOnHover && setShowMenu(true); }, show: !disabled && displayOnHover && showMenu, onMouseLeave: function () { return displayOnHover && setShowMenu(false); }, onToggle: function (isOpen) { return setShowMenu(isOpen); }, className: dropdownClassName },
        react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { as: (toggleAs !== null && toggleAs !== void 0 ? toggleAs : toggleVariant === 'link') ? AcDropdownLinkToggle_1.AcDropdownLinkToggle : AcDropdownToggle_1.AcDropdownToggle, id: id, className: "" + toggleClassNameNode, variant: toggleVariant, readOnly: readOnly, 
            // `size` props cannot be used as it is not support custom size
            toggleSize: toggleSize, disabled: disabled, active: (!disabled && showMenu) || toggleActive, disableDropdownIcon: disableDropdownIcon },
            react_1.default.createElement(react_1.default.Fragment, null, titleNode)),
        react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, { popperConfig: {
                strategy: 'fixed',
                modifiers: [
                    // displayOnHover cannot have offset
                    !displayOnHover
                        ? {
                            name: 'offset',
                            options: {
                                offset: [0, 8],
                            },
                        }
                        : {},
                ],
            }, style: __assign({ minWidth: menuMinWidth }, renderStyle()), onMouseLeave: function () { return setShowMenu(false); } },
            actions
                .filter(function (action) {
                if (typeof action.hide === 'function') {
                    return !action.hide(data || {}, functionContext || {});
                }
                return !action.hide;
            })
                .map(function (action, index) { return (react_1.default.createElement(AcDropdownItem_1.AcDropdownItem, { onMouseDown: onMouseDown, onClickBeforeAction: function () { return displayOnHover && setShowMenu(false); }, key: "" + index, eventKey: "" + index, data: data, functionContext: functionContext, action: action, size: dropdownSize })); }),
            children)));
};
exports.AcDropdown = AcDropdown;
exports.AcDropdown.displayName = 'AcDropdown';
//# sourceMappingURL=AcDropdown.js.map